// extracted by mini-css-extract-plugin
module.exports = {"author":"Author_author__pnaHt","authorInfo":"Author_authorInfo__cGopN","name":"Author_name__Hn1rO","authorPhoto":"Author_authorPhoto__OUsak"};